export const ADDRESS_WITH_NAME_REGEX = /^(.*?)\s*<([^>]*)>$/;

export const EMAIL_REGEX = /([a-zA-Z0-9._%+-])[a-zA-Z0-9._%+-]*(@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

export const PHONE_REGEX = new RegExp(
  '(?<![A-Za-z0-9-])(?:' +
    '\\+\\d{7,15}' +
    '|\\+\\d{1,3}[\\s.-]\\d{3,5}[\\s.-]\\d{3,5}(?:[\\s.-]\\d{2,5})?' +
    '|\\(\\d{2,4}\\)[\\s.-]?\\d{2,4}[\\s.-]?\\d{4}' +
    '|(?:\\+\\d{1,3}[\\s.-])?\\d{2,4}[\\s.-]\\d{2,4}[\\s.-]\\d{4}' +
    '|\\d{3}[\\s.-]\\d{4}' +
    ')(?![A-Za-z0-9-])',
  'g'
);

export const SOCIAL_PATH = '[\\w\\-/?=&%]+(?:\\.[\\w\\-/?=&%]+)*';
export const SOCIAL_HANDLE = '[\\w-]+(?:\\.[\\w-]+)*';

export const GENERAL_SOCIAL_URL_REGEX = new RegExp(
  [
    String.raw`(?<![\w.-])(?:https?://)?(?:[a-z0-9-]+\.)*linkedin\.com/(?:in|pub)/` + SOCIAL_PATH,
    String.raw`(?<![\w.-])(?:https?://)?lnkd\.in/` + SOCIAL_PATH,
    String.raw`(?<![\w.-])(?:https?://)?(?:[a-z0-9-]+\.)*(?:twitter\.com|x\.com)/` +
      SOCIAL_HANDLE +
      String.raw`(?:/status/\d+)?`,
    String.raw`(?<![\w.-])(?:https?://)?(?:[a-z0-9-]+\.)*facebook\.com/` + SOCIAL_PATH,
    String.raw`(?<![\w.-])(?:https?://)?(?:[a-z0-9-]+\.)*instagram\.com/` + SOCIAL_PATH,
  ].join('|'),
  'gi'
);

export const GITHUB_URL_REGEX = new RegExp(
  '(?<![\\w.-])(?:https?://)?(?:[a-z0-9-]+\\.)*github\\.com/(' +
    SOCIAL_HANDLE +
    ')((?:/' +
    SOCIAL_HANDLE +
    ')*)/?',
  'gi'
);

export const ROLE_WORDS = new Set([
  'team',
  'sales',
  'support',
  'noreply',
  'no-reply',
  'info',
  'hr',
  'admin',
  'help',
  'service',
  'careers',
  'recruitment',
  'billing',
  'accounts',
  'contact',
  'notifications',
  'alerts',
  'hello',
  'orders',
  'jobs',
  'marketing',
  'office',
  'press',
  'legal',
  'finance',
  'payroll',
  'enquiries',
  'reception',
  'talent',
  'recruiter',
  'mailer-daemon',
]);

export const GENERIC_ADDRESSEES = new Set([
  ...ROLE_WORDS,
  'everyone',
  'all',
  'there',
  'folks',
  'friend',
  'valued',
  'customer',
  'sir',
  'madam',
  'i',
  'we',
  'the',
  'please',
  'hiring',
  'manager',
  'guys',
  'applicant',
]);

export const PARTICLES = new Set([
  'dr',
  'mr',
  'mrs',
  'ms',
  'jr',
  'sr',
  'ii',
  'iii',
  'van',
  'der',
  'de',
  'la',
  'von',
  'da',
  'do',
  'du',
  'bin',
  'al',
]);

export const REDACTED_LINK = '[LINK REDACTED]';
export const REDACTED_FIELD = '[REDACTED]';

export const COMMON_WORD_NAMES = new Set([
  'will',
  'hope',
  'grace',
  'rose',
  'may',
  'bill',
  'art',
  'frank',
  'mark',
  'drew',
  'faith',
  'joy',
  'dawn',
  'summer',
  'june',
  'august',
  'sky',
  'star',
  'rich',
  'victor',
  'chase',
  'patience',
]);

export const GREETING_REGEX =
  /\b(?:Hi|Hello|Dear|Hey)\s+([\p{Lu}][\p{L}'-]*(?:\s[\p{Lu}][\p{L}'-]*)?)(?!\*)\s*[,!]/gu;
export const SIGNOFF_REGEX =
  /\b(?:Regards|Thanks|Best(?: regards)?|Sincerely|Cheers|Kind regards)\s*,\s*([\p{Lu}][\p{L}'-]*(?:\s[\p{Lu}][\p{L}'-]*)?)(?!\*)(?=[.,!?]?\s*(?:\n|$))/gu;

export const PROTECTED_SPAN_PATTERNS = [
  /\[(?:[A-Z ]+ )?REDACTED\]/g,
  /\S+\*\*\*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
  /https?:\/\/\S+/g,
  /\bwww\.[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+\S*/g,
];
